require('es6-promise').polyfill() // ie & 360   https://blog.csdn.net/cdut100/article/details/81091198

import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import App from '@/App'


import './init'
import '@babel/polyfill'

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')



